module.exports = __webpack_public_path__ + "media/images/official/guide_kv-b20913336c954713c97bf7fba0e3a02e.svg";